/** Evita que la rueda del mouse cambie el valor cuando un input number tiene foco. */
export function setupNumberInputs() {
  document.addEventListener(
    'wheel',
    (event) => {
      const el = document.activeElement;
      if (!(el instanceof HTMLInputElement) || el.type !== 'number') return;

      event.preventDefault();
      el.blur();
      window.scrollBy({ top: event.deltaY, left: event.deltaX, behavior: 'auto' });
    },
    { passive: false, capture: true }
  );
}
